<template>
  <div>
    <el-table
      border
      :data="tableData"
      size="medium"
      :span-method="objectSpanMethod"
    >
      <el-table-column align="center" label="品目信息">
        <el-table-column align="center" label="序号" prop="index" width="50">
          <template slot-scope="{ row, $index }">
            <span>{{ indexNum(row, $index) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="品目信息" min-width="170">
          <template slot-scope="{ row }">
            <div class="table-item flex-align__around">
              <div class="column">
                <div class="column-item">
                  <div class="column-item__title">品目编码</div>
                  <div class="column-item__content">
                    {{ row.itemCode || ' - ' }}
                  </div>
                </div>
                <div class="column-item">
                  <div class="column-item__title">品目名称</div>
                  <div class="column-item__content">
                    {{ row.itemName || ' - ' }}
                  </div>
                </div>
                <div class="column-item">
                  <div class="column-item__title">参数型号</div>
                  <div class="column-item__content">
                    {{ row.itemModel || ' - ' }}
                  </div>
                </div>
                <div class="column-item">
                  <div class="column-item__title">交货地点</div>
                  <div class="column-item__content">
                    {{ row.deliveryAddress || ' - ' }}
                  </div>
                </div>
                <div class="column-item">
                  <div class="column-item__title">数量</div>
                  <div class="column-item__content">
                    {{ row.itemNum ? strToThousands(row.itemNum) : 0 }}
                  </div>
                </div>
                <div class="column-item">
                  <div class="column-item__title">授标量</div>
                  <div class="column-item__content">
                    {{ row.awardNum ? strToThousands(row.awardNum) : 0 }}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="价格" width="170">
          <template slot-scope="{ row }">
            <div class="table-item">
              <div class="column">
                <div class="column-item">
                  <div class="column-item__title">预算单价</div>
                  <div class="column-item__content">
                    {{ row.unitPrice ? strToThousands(row.unitPrice) : '-' }}
                    元
                  </div>
                </div>
                <div class="column-item">
                  <div class="column-item__title">总价</div>
                  <div class="column-item__content">
                    {{ row.totalPrice ? strToThousands(row.totalPrice) : '-' }}
                    元
                    <money-in-cn
                      :money="row.totalPrice"
                      :ellipsis="false"
                      width="100px"
                    />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="候选供应商" align="center">
        <el-table-column align="center" label="供应商名称" min-width="140">
          <template slot-scope="{ row }">
            <span>{{ row.supplierName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="中标总价(元)" min-width="100">
          <template slot-scope="{ row }">
            <span>{{
              Number(row.bargainAmount)
                ? strToThousands(row.bargainAmount)
                : strToThousands(row.awardAmount)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="议价(元)" min-width="90">
          <template slot-scope="{ row }">
            <span>{{
              row.bargainAmount ? strToThousands(row.bargainAmount) : '-'
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="right"
          header-align="center"
          :label="requireTax ? '含税价' : '未含税价'"
        >
          <template slot-scope="{ row }">
            <span>
              {{ row.offerPrice ? strToThousands(row.offerPrice) : '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="requireTax"
          align="right"
          header-align="center"
          label="税率"
        >
          <template slot-scope="{ row }">
            <span>
              {{ row.offerTaxRate ? strToThousands(row.offerTaxRate) : '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="right" header-align="center" label="授标数量">
          <template slot-scope="{ row }">
            <span>
              {{ row.awardNum ? strToThousands(row.awardNum) : '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="品牌/制造商" min-width="100">
          <template slot-scope="{ row }">
            <span>{{ row.offerItemBrand || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="交货时间(天)" min-width="120">
          <template slot-scope="{ row }">
            <span>{{ row.offerDeliveryDay || '-' }}</span>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
// 组件
import MoneyInCn from '@/components/common/MoneyInCn'
// 工具方法
import { strToThousands } from '@/utils/utils'

export default {
  name: 'AwardSheet',

  components: {
    MoneyInCn
  },

  props: {
    tableData: {
      type: Array,
      default: () => []
    },

    // 跨越行数对象，key为品目id，value为当前品目需要跨越的行数
    spanNumObj: {
      type: Object,
      default: () => {}
    },

    // 是否含税
    requireTax: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    indexNum() {
      return (row, index) => {
        return this.spanNumObj[row.itemId].index || 1
      }
    }
  },

  methods: {
    strToThousands,

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      const tempObj = this.spanNumObj[row.itemId]
      const spanNum = tempObj.num || 1
      const tempIndexArray = [0, 1, 2]
      if (tempIndexArray.indexOf(columnIndex) > -1) {
        if (rowIndex === tempObj.start) {
          return {
            rowspan: spanNum,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

.table-item {
  .column {
    margin-right: pixel-to-rem($n: 20);

    &:first-child {
      flex: 2;
    }

    &:last-child {
      flex: 1;
      margin-right: 0;
    }

    .column-item {
      display: flex;
      align-items: flex-start;

      .column-item__title {
        @include text-bold;
        white-space: nowrap;
        flex: 1;
        text-align: right;

        &::after {
          content: '：';
          display: inline-block;
        }
      }

      .column-item__content {
        flex: 1;
        margin: 0;
        text-align: left;
      }
    }
  }
}
</style>
